/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Imageuploadremove2Inputs */

const en_imageuploadremove2 = /** @type {(inputs: Imageuploadremove2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove image`)
};

const de_imageuploadremove2 = /** @type {(inputs: Imageuploadremove2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild entfernen`)
};

/**
* | output |
* | --- |
* | "Remove image" |
*
* @param {Imageuploadremove2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const imageuploadremove2 = /** @type {((inputs?: Imageuploadremove2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Imageuploadremove2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_imageuploadremove2(inputs)
	return de_imageuploadremove2(inputs)
});
export { imageuploadremove2 as "imageUploadRemove" }